var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools02-useage-guide"},[_c('el-row',[_c('el-col',[(_vm.tool.codeKebab === 'cart-system')?_c('h2',[_vm._v("解約・休止について")]):_c('h2',[_vm._v("利用設定・利用ステータス・ポイント消化について")])])],1),_c('el-row',[_c('el-col',[_c('Description')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }